import { catalog as usCatalog } from "@unauthenticated/catalog/locales/en/US/catalog";

export const catalog = {
  ...usCatalog,
  SearchProducts: "Search over 3,000 products...",
} as const;
